import { Flash, unit } from '@acast/decibel';
import T from 'prop-types';
import styled from 'styled-components';
import React from 'react';
import Field from 'shared/components/field';
import UploadableImage from 'shared/components/uploadable-image';

const DEFAULT_SHOW_COVER_IMAGE = '/assets/images/default-show.png';

const Container = styled.div`
  background-color: #f9fafb;
  border: 1px dashed ${props => (props.invalid ? '#ec5148' : '#a1a4aa')};
  border-radius: 2px;
  padding: ${unit(2)} 0;

  & .uploadable-image {
    width: ${unit(50)};
    margin: 0 auto;
  }
`;

function Image({ showId, onChange, meta, value, label, help, isRequired }) {
  const { error } = meta;

  const getErrorMessage = () => (error ? <Flash intent="danger">{error}</Flash> : null);

  return (
    <Field label={label} subtitle={help} isRequired={isRequired}>
      <Container invalid={!!error}>
        <UploadableImage
          entity={showId}
          src={value || DEFAULT_SHOW_COVER_IMAGE}
          role="presentation"
          onImageUploaded={val => {
            return onChange(val);
          }}
          onImageRemoved={() => onChange(null)}
          enableRemove={!!value}
        />
      </Container>
      {getErrorMessage()}
    </Field>
  );
}

Image.propTypes = {
  onChange: T.func,
  meta: T.object,
  value: T.any,
  label: T.string,
  help: T.string,
  showId: T.string,
  isRequired: T.bool,
};

export default Image;
